import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './OptionRenderer.css';

const optionsBlockRenderer = params =>
  <div className={s.optionsBlock}>
    <span
      className={cx(
        s.optionItem,
        params.disabled ? s.optionItemDisabled : s.optionItemActive,
      )}
    >
      {params.title}
    </span>
  </div>;

export default withStyles(s)(optionsBlockRenderer);



// WEBPACK FOOTER //
// ./src/desktop/components/LocationsBlock/OptionRenderer/OptionRenderer.js